export default () => (
  <svg width='192' height='192' viewBox='0 0 192 192' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M155.975 86.079C155.992 85.5785 156 85.0759 156 84.5714C156 59.9553 136.122 40 111.6 40C92.1479 40 75.6175 52.5574 69.6141 70.0375C65.3027 67.7789 60.3999 66.5019 55.2 66.5019C37.9687 66.5019 24 80.5246 24 97.8224C24 115.12 37.9687 129.143 55.2 129.143L111.66 129.143H145.2C157.792 129.143 168 118.896 168 106.255C168 97.5266 163.133 89.9395 155.975 86.079Z'
      fill='white'
    />
  </svg>
);
